<template>
  <AuthPage :page="page">
    <LoginForm @login="handleContinue" @goToRegister="goToRegister" />
  </AuthPage>
</template>

<script>
import LoginForm from '@/components/Account/LoginForm'
import AuthPage from '@/components/Account/AuthPage'
import { getPages, meta } from '@/mixins/content'
import auth from '@/mixins/auth'

export default {
  transition: 'fade',

  layout: 'auth',

  components: { LoginForm, AuthPage },

  mixins: [auth, meta, getPages(['auth-pages/login'])],

  middleware: ['requires-no-auth'],

  methods: {
    // handleContinue() in Auth Mixin

    // Run from Auth Mixin
    handleAuth() {
      let path = this.$route.query.app_return_path || '/dashboard/latest'

      this.$router.replace({
        path,
        query: Object.assign(
          { ...this.$route.query },
          { app_return_path: undefined }
        ),
      })
    },

    goToRegister() {
      this.$router.push({ path: '/register', query: { ...this.$route.query } })
    },
  },
}
</script>
